import React from 'react';

import { ReactComponent as IconDown } from '../../../assets/icon/ic_arrow_down.svg';

const DropdownIndicator = () => {
  return <IconDown width={16} height={16} className="mr-[6px] text-text-second hover:text-primary-hover" />;
};

export default DropdownIndicator;
